"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTransactionValidation = void 0;
const PaymentStateValidation_1 = require("./PaymentStateValidation");
class PaymentTransactionValidation {
    static isValid(entity) {
        // Validate entity.id for existence and correct type.
        if (entity.id == undefined)
            return false;
        if (typeof entity.id !== "string")
            return false;
        // If entity.payment_presented_timestamp exists, validate that it has the correct type.
        if (entity.payment_presented_timestamp != undefined) {
            if (!(entity.payment_presented_timestamp instanceof Date))
                return false;
        }
        // If entity.payment_token exists, validate that it has the correct type.
        if (entity.payment_token != undefined) {
            if (typeof entity.payment_token !== "string")
                return false;
        }
        // If entity.unique_reference exists, validate that it has the correct type.
        if (entity.unique_reference != undefined) {
            if (typeof entity.unique_reference !== "string")
                return false;
        }
        // If entity.payment_terminal_id exists, validate that it has the correct type.
        if (entity.payment_terminal_id != undefined) {
            if (typeof entity.payment_terminal_id !== "string")
                return false;
        }
        // Validate entity.last_known_state for existence and correct type.
        if (entity.last_known_state == undefined)
            return false;
        if (!PaymentStateValidation_1.PaymentStateValidation.isValid(entity.last_known_state))
            return false;
        // If entity.port_id exists, validate that it has the correct type.
        if (entity.port_id != undefined) {
            if (typeof entity.port_id !== "number")
                return false;
        }
        // If entity.ocpi_tracking_id exists, validate that it has the correct type.
        if (entity.ocpi_tracking_id != undefined) {
            if (typeof entity.ocpi_tracking_id !== "string")
                return false;
        }
        // If entity.authorization_type_money_PaymentAuthorizationType exists, validate that it has the correct type.
        if (entity.authorization_type_money_PaymentAuthorizationType != undefined) {
            if (typeof entity.authorization_type_money_PaymentAuthorizationType !==
                "number")
                return false;
        }
        // If entity.error_code_money_CardPaymentError exists, validate that it has the correct type.
        if (entity.error_code_money_CardPaymentError != undefined) {
            if (typeof entity.error_code_money_CardPaymentError !== "number")
                return false;
        }
        // If entity.authorization_success exists, validate that it has the correct type.
        if (entity.authorization_success != undefined) {
            if (typeof entity.authorization_success !== "boolean")
                return false;
        }
        // If entity.capture_success exists, validate that it has the correct type.
        if (entity.capture_success != undefined) {
            if (typeof entity.capture_success !== "boolean")
                return false;
        }
        // If entity.max_authorized_amount_money_Money_json exists, validate that it has the correct type.
        if (entity.max_authorized_amount_money_Money_json != undefined) {
            if (typeof entity.max_authorized_amount_money_Money_json !== "string")
                return false;
        }
        // If entity.free_reason_money_FreeReason exists, validate that it has the correct type.
        if (entity.free_reason_money_FreeReason != undefined) {
            if (typeof entity.free_reason_money_FreeReason !== "number")
                return false;
        }
        // If entity.expiry_time exists, validate that it has the correct type.
        if (entity.expiry_time != undefined) {
            if (!(entity.expiry_time instanceof Date))
                return false;
        }
        // If entity.pricing_model_money_PricingModel_json exists, validate that it has the correct type.
        if (entity.pricing_model_money_PricingModel_json != undefined) {
            if (typeof entity.pricing_model_money_PricingModel_json !== "string")
                return false;
        }
        // If entity.resolved_pricing_model_money_PricingModel_json exists, validate that it has the correct type.
        if (entity.resolved_pricing_model_money_PricingModel_json != undefined) {
            if (typeof entity.resolved_pricing_model_money_PricingModel_json !==
                "string")
                return false;
        }
        // If entity.charge_breakdown_money_ChargeBreakdown_json exists, validate that it has the correct type.
        if (entity.charge_breakdown_money_ChargeBreakdown_json != undefined) {
            if (typeof entity.charge_breakdown_money_ChargeBreakdown_json !== "string")
                return false;
        }
        // If entity.provider_receipt_json exists, validate that it has the correct type.
        if (entity.provider_receipt_json != undefined) {
            if (typeof entity.provider_receipt_json !== "string")
                return false;
        }
        // If entity.authorization_status_money_PaymentAuthorizationStatus exists, validate that it has the correct type.
        if (entity.authorization_status_money_PaymentAuthorizationStatus != undefined) {
            if (typeof entity.authorization_status_money_PaymentAuthorizationStatus !==
                "number")
                return false;
        }
        // If entity.final_amount exists, validate that it has the correct type.
        if (entity.final_amount != undefined) {
            if (typeof entity.final_amount !== "number")
                return false;
        }
        // If entity.savings_amount exists, validate that it has the correct type.
        if (entity.savings_amount != undefined) {
            if (typeof entity.savings_amount !== "number")
                return false;
        }
        // If entity.precision exists, validate that it has the correct type.
        if (entity.precision != undefined) {
            if (typeof entity.precision !== "number")
                return false;
        }
        return true;
    }
}
exports.PaymentTransactionValidation = PaymentTransactionValidation;
